module.exports = __webpack_public_path__ + "img/syukyaku-landing-001.586a0c97.jpg";